import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'moveMarkets',
        (state.get('moveMarkets') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'moveMarkets',
        (state.get('moveMarkets') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state, {result}) {
    let items = state.get('items');
    result.forEach((res) => {
        let item = items.get(res.id) || Map();
        items = items.set(res.id, item.set('displayOrder', res.displayOrder));
    });
    return state
        .set('items',items)
        .set(
            'moveMarkets',
            (state.get('moveMarkets') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}
